import React from 'react';
// import __ from 'lodash';
 
// object entity besar kecil

class DropdownSekolahEntity extends React.Component {
    render() {
        return (
            this.props.sekolah.map(val =>
                <option key={val.idSekolah} value={val.idSekolah}>{val.namaSekolah}</option>
            )
        )
    }
}

export default DropdownSekolahEntity;